class ModalWindow extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.debug = false;
    if (this.debug) console.log('ModalWindow constructor');
  }

  connectedCallback() {
    if (this.debug) console.log('ModalWindow connected callback');
    this.attachModalListeners();
  }

  attachModalListeners() {
    const close_element = this.querySelector('.close');
    //    console.log('ModalWindow connectedCallback');
    // get all [data-open-modal] elements
    const modalTriggers = document.querySelectorAll('[data-open-modal]');
    // loop through each element
    modalTriggers.forEach((modalTrigger) => {
      // add a click event listener
      modalTrigger.addEventListener('click', (event) => {
        // get the value of the data-open-modal attribute
        // prevent the default behavior
        event.preventDefault();
        const modalId = modalTrigger.getAttribute('data-open-modal');
        //        console.log(modalId);
        // find the element by ID
        const modalElement = document.querySelector(modalId);
        //        console.log(modalElement);
        // check if the element was found
        if (modalElement) {
          if (modalElement.classList.contains('modal-show')) {
            modalElement.classList.remove('modal-visuallyshow');
            setTimeout(function () {
              modalElement.classList.remove('modal-show');
            }, 2000);
          } else {
            modalElement.classList.add('modal-show');
            setTimeout(() => {
              modalElement.classList.add('modal-visuallyshow');
            }, 1);
          }
          modalElement.style.display = 'block';
          // add overflow hidden to body
          document.body.style.overflow = 'hidden';
          // fire custom event of a modal window opening
          document.dispatchEvent(new CustomEvent('modal-window-opened'));
          // add the Modal--open class to the modal element
          //          modalElement.classList.add('Modal--open');
          // add the State--modal-open class to the <html> element
          //          document.documentElement.classList.add('State--modal-open');
        }
      });
    });

    // When the user clicks anywhere outside of the modal, close it
    window.addEventListener('click', (event) => {
      if (event.target === this) {
        this.hide();
      }
    });

    close_element.addEventListener('click', () => {
      this.hide();
    });
  }

  hide() {
    this.style.display = 'none';
    this.classList.remove('modal-visuallyshow');
    this.classList.remove('modal-show');
    // remove overflow hidden from body
    document.body.style.overflow = 'auto';
    // send a custom event of a modal window closing
    document.dispatchEvent(new CustomEvent('modal-window-closed'));
  }
}

customElements.define('modal-window', ModalWindow);
